import mainService from './mainService';

export function analysisData(portId: number, data: object) {
    return mainService
        .post(`analysis/${portId}/data`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function profileHistogram(portId: number, data: object) {
    return mainService
        .post(`analysis/${portId}/histogram`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function locateDistance(portId: number, data: object) {
    return mainService
        .post(`analysis/${portId}/locate`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function chainageData(portId: number, data: object) {
    return mainService
        .post(`analysis/${portId}/chainage`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
